<template>    
        <div class="search-item" >  
            <div v-if="hasHttp(slug)">
                <div class="search-item-inner-wrap">                     
                    <a :href="slug" target="_blank">
                        <div class="name">{{ name }}</div>
                        <div class="short_desc" v-if="short_desc">{{ short_desc }}</div>
                    </a>   
                </div>
            </div>
            <div v-else>
                <div v-if="from_table=='category'" class="search-item-inner-wrap">
                    <router-link v-if="!hasHttp(slug_path)" :to="{path: slug_path}">
                        <div class="name">{{ name }}</div>
                        <div class="short_desc" v-if="short_desc">{{ short_desc }}</div>
                    </router-link>                            
                </div>
                <div v-else-if="type=='product' && categoryArrayProduct.length > 0" class="search-item-inner-wrap">
                    <router-link :to="{name:'ProductDetails_' + currentLangName(), params:{ product_slug: slug, product_category_slug: getProdCatslug[0].slug}}">
                        <div class="name">{{ name }}</div>
                        <div class="short_desc" v-if="short_desc">{{ short_desc }}</div>
                    </router-link>                
                </div>
                <div v-else-if="type=='recipe' && categoryArrayRecipes.length > 0" class="search-item-inner-wrap">
                    <router-link :to="{ name:'RecipeDetails_' + currentLangName(), params: {recipe_slug: slug, recipes_category_slug: getRecipeCatslug[0].slug}}">
                        <div class="name">{{ name }}</div>
                        <div class="short_desc" v-if="short_desc">{{ short_desc }}</div>
                    </router-link>                
                </div>
                <div v-else-if="type=='news' && categoryArrayNews.length > 0" class="search-item-inner-wrap">
                    <router-link :to="{ name:'NewsDetails_' + currentLangName(), params: {news_slug: slug, news_category_slug: getNewsCatslug[0].slug}}">
                        <div class="name">{{ name }}</div>
                        <div class="short_desc" v-if="short_desc">{{ short_desc }}</div>
                    </router-link>                
                </div>   
                <div v-else-if="type=='career'" class="search-item-inner-wrap">
                    <router-link :to="{ name:'CareerDetails_' + currentLangName(), params: {career_slug: slug}}">
                        <div class="name">{{ name }}</div>
                        <div class="short_desc" v-if="short_desc">{{ short_desc }}</div>
                    </router-link>                
                </div>                       
            </div>           
        </div>
</template>

<script>
export default {   
    props: ['id', 'name', 'slug', 'type', 'short_desc', 'slug_path', 'from_table'],
    computed:{
        categoryArrayProduct(){
            return this.$store.getters.getProducstCategory
        },
        categoryArrayRecipes(){
            return this.$store.getters.getRecipesCategory
        },
        categoryArrayNews(){
            return this.$store.getters.getNewsCategory
        },
        getProdCatslug(){                                 
            // let categoryArray = this.$store.getters.getProducstCategory;                   
            return this.getCategoryData(this.id, this.categoryArrayProduct  )
        },
        getRecipeCatslug(){             
            // let categoryArray = this.$store.getters.getRecipesCategory;                   
            return this.getCategoryData(this.id, this.categoryArrayRecipes  )
        },
        getNewsCatslug(){             
            // let categoryArray = this.$store.getters.getNewsCategory;                   
            return this.getCategoryData(this.id, this.categoryArrayNews  )
        }       
    }
}
</script>